var interact = {};
// ACCORDION
interact.accordion = function (options) {
    'use strict';
    var self = this;
    self.Opt = new interact.accordion.opt(options);
    var animate = function (obj) {
        if (self.Opt.State === 'open') {
            //    obj.slideDown(self.Opt.Speed, function () {
            //        if (self.Opt.OpenCallBack) {
            //            self.Opt.OpenCallBack(self.Opt);
            //        }
            //    });
            $(obj).show();
        } else {
            //    obj.slideUp(self.Opt.Speed, function () {
            //        if (self.Opt.CloseCallBack) {
            //            self.Opt.CloseCallBack(self.Opt);
            //        }
            //    });
            $(obj).hide();
        }
    };
    var init = (function () {
        self.Opt.InitialSelector = self.Opt.Selector;
        for (var i = 0; i < $(self.Opt.Wrap).length; i++) {
            //add an id to each accordion section if it doesn't already have one
            var id;
            if ($(self.Opt.Wrap).eq(i).attr('id')) {
                id = $(self.Opt.Wrap).eq(i).attr('id');
            }
            else {
                id = 'accordion_' + i;
                $(self.Opt.Wrap).eq(i).attr('id', id);
            }
            self.Opt.Selector = '#' + id + ' ' + self.Opt.InitialSelector;
            switch (self.Opt.Start) {
                case 'closed':
                    $(self.Opt.Selector).each(function (i, ele) {
                        if (!$(ele).hasClass('open')) {
                            // explicitly set the height on the element to allow the calculation below to work (as element is hidden)
                            //$(ele).next().height($(ele).next().height());
                            //$(window).on('resize', function () {
                            //    $(ele).next().height(function () {
                            //        $(this).css({
                            //            'height': 'auto'
                            //        });
                            //        return $(this).height();
                            //    });
                            //});
                            $(ele).next().hide();
                        }
                    });
                    break;
                case 'open':
                    $(self.Opt.Selector).addClass('open');
                    $(ele).next().show();
            }
            $(self.Opt.Selector).on('click', function () {
                self.Opt.Speed = $(this).next().height() * self.Opt.SpeedMod;
                self.Opt.Speed = 0;
                var obj = $(this).next();
                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    self.Opt.State = 'closed';
                    animate(obj);
                }
                else {
                    if (!self.Opt.MultiOpen) {
                        // find the open drawer, remove the class, move to the next element following it and hide it
                        var prevObj;
                        if (self.Opt.Parent !== '') {
                            prevObj = $(self.Opt.Parent).find('.open');
                        }
                        else {
                            prevObj = $(this).parent().find('.open');
                        }
                        if (prevObj.length > 0) {
                            $(prevObj).removeClass('open');
                            prevObj = prevObj.next();
                            self.Opt.State = 'closed';
                            animate(prevObj);
                        }
                    }
                    // add the open class to this A, move to the next element (i.e UL) and show it
                    $(this).addClass('open');
                    self.Opt.State = 'open';
                    animate(obj);
                }
                return false;
            });
            if (self.Opt.BuildCallBack) {
                self.Opt.BuildCallBack(self.Opt);
            }
            if (self.Opt.CheckUrl) {
                var url = document.location.toString();
                if (url.match('#')) {
                    var selectedAccordion = $('#' + url.split('#')[1]);
                    if (selectedAccordion.length) {
                        selectedAccordion.addClass('open');
                        selectedAccordion.next().show();
                        $('html, body').animate({
                            scrollTop: selectedAccordion.offset().top - 30
                        }, 50);
                    }
                }
            }
        }
    })();
    var openAll = function () {
        self.Opt.State = 'open';
        $(self.Opt.Selector).addClass('open');
        var obj = $(self.Opt.Selector).next();
        animate(obj);
    };
    this.OpenAll = openAll;
    var closeAll = function () {
        self.Opt.State = 'closed';
        $(self.Opt.Selector).removeClass('open');
        var obj = $(self.Opt.Selector).next();
        animate(obj);
    };
    this.CloseAll = closeAll;
};
interact.accordion.opt = function (options) {
    'use strict';
    options && options.wrapper ? this.Wrap = options.wrapper : this.Wrap = '.accordionWrapper';
    options && options.selector ? this.Selector = options.selector : this.Selector = '.accordion';
    options && options.checkUrl ? this.CheckUrl = options.checkUrl : this.CheckUrl = false;
    options && options.start ? this.Start = options.start : this.Start = 'closed';
    options && options.speedMod ? this.SpeedMod = options.speedMod : this.SpeedMod = 1;
    options && options.parent ? this.Parent = options.parent : this.Parent = '';
    options && options.buildCallBack ? this.BuildCallBack = options.buildCallBack : this.BuildCallBack = '';
    options && options.openCallBack ? this.OpenCallBack = options.openCallBack : this.OpenCallBack = '';
    options && options.closeCallBack ? this.CloseCallBack = options.closeCallBack : this.CloseCallBack = '';
    options && options.multiOpen ? this.MultiOpen = options.multiOpen : this.MultiOpen = false;
};
// TABS
interact.tabs = function (options) {
    'use strict';
    var self = this;
    self.Opt = new interact.tabs.opt(options);
    var animate = function (obj, tab) {
        switch (self.Opt.Transition) {
            case 'none':
                $(obj).hide(0, function () {
                    bindTabEvents();
                    $(this).removeClass(self.Opt.CurrentTabClass);
                    tab.addClass(self.Opt.CurrentTabClass).show(0);
                    if (self.Opt.ChangeCallBack) {
                        self.Opt.ChangeCallBack(self.Opt);
                    }
                });
                break;
            case 'fade':
                $(obj).fadeOut(self.Opt.TransitionSpeed, function () {
                    bindTabEvents();
                    $(this).removeClass(self.Opt.CurrentTabClass);
                    tab.addClass(self.Opt.CurrentTabClass).fadeIn(self.Opt.TransitionSpeed);
                    if (self.Opt.ChangeCallBack) {
                        self.Opt.ChangeCallBack(self.Opt);
                    }
                });
                break;
            case 'slide':
                $(obj).slideUp(self.Opt.TransitionSpeed, function () {
                    bindTabEvents();
                    $(this).removeClass(self.Opt.CurrentTabClass);
                    tab.addClass(self.Opt.CurrentTabClass).slideDown(self.Opt.TransitionSpeed);
                    if (self.Opt.ChangeCallBack) {
                        self.Opt.ChangeCallBack(self.Opt);
                    }
                });
        }
        if (self.Opt.AddHashValue) {
            if ($(self.Opt.TabsContainer + '>:nth-child(' + tab + ')').attr('id')) {
                window.location.hash = 'tab-' + $(self.Opt.TabsContainer + '>:nth-child(' + tab + ')').attr('id');
            }
        }
    };
    var bindTabEvents = function () {
        $(self.Opt.TabsContainer).children().off('click.tab').off('click.blank').on('click.tab', function () {
            $(self.Opt.TabsContainer).children().off('click.tab');
            $(self.Opt.TabsContainer).children().on('click.blank', function () {
                return false;
            });
            $(this).siblings().removeClass(self.Opt.SelectedTabClass);
            $(this).addClass(self.Opt.SelectedTabClass);
            var tabIndex = $(self.Opt.TabsContainer).children().index($(this)) + 1;
            var tab = $(self.Opt.TabContentContainer + '>:nth-child(' + tabIndex + ')');
            animate($(self.Opt.TabContentContainer).children(' .' + self.Opt.CurrentTabClass), tab);
            return false;
        });
    };
    var setTabState = function (reset) {
        // hide all tab's content and only show the selected tab
        $(self.Opt.TabContentContainer).children().hide();
        if (reset) {
            $(self.Opt.TabsContainer).children().removeClass(self.Opt.SelectedTabClass);
        }
        // if no tab has been set as selected in the markup, look to see if a hash value has been set in the URL and use this, otherwise assume it is the first tab
        if (!$(self.Opt.TabsContainer).children().hasClass(self.Opt.SelectedTabClass)) {
            $(self.Opt.TabsContainer + '>:first-child').addClass(self.Opt.SelectedTabClass);
            if (self.Opt.AddHashValue && window.location.hash) {
                var tabToSelect = window.location.hash.split('-');
                $.each($(self.Opt.TabsContainer).children(), function () {
                    if ($(this).attr('id') === tabToSelect[1]) {
                        $(this).siblings().removeClass(self.Opt.SelectedTabClass);
                        $(this).addClass(self.Opt.SelectedTabClass);
                    }
                });
            }
        }
        var selected = $(self.Opt.TabsContainer + ' .' + self.Opt.SelectedTabClass).index() + 1;
        $(self.Opt.TabContentContainer + '>:nth-child(' + selected + ')').addClass(self.Opt.CurrentTabClass).show();
    };
    this.SetTabState = setTabState;
    var init = (function () {
        for (var i = 0; i < $(self.Opt.Wrap).length; i++) {
            var id;
            if ($(self.Opt.Wrap).eq(i).attr('id')) {
                id = $(self.Opt.Wrap).eq(i).attr('id');
            }
            else {
                id = 'tabs_' + i;
                $(self.Opt.Wrap).eq(i).attr('id', id);
            }
            self.Opt.TabsContainer = '#' + id + ' ' + self.Opt.TabsContainer;
            self.Opt.TabContentContainer = '#' + id + ' ' + self.Opt.TabContentContainer;           
            setTabState();
            // change the displayed content when a tab is clicked on
            bindTabEvents();
            if (self.Opt.BuildCallBack) {
                self.Opt.BuildCallBack(self.Opt);
            }
        }
    })();
};
interact.tabs.opt = function (options) {
    'use strict';
    options && options.wrapper ? this.Wrap = options.wrapper : this.Wrap = '.tabsWrapper';
    options && options.tabsContainer ? this.TabsContainer = options.tabsContainer : this.TabsContainer = '.tabs';
    options && options.tabContentContainer ? this.TabContentContainer = options.tabContentContainer : this.TabContentContainer = '.tabContent';
    options && options.selectedTabClass ? this.SelectedTabClass = options.selectedTabClass : this.SelectedTabClass = 'selectedTab';
    options && options.currentTabClass ? this.CurrentTabClass = options.currentTabClass : this.CurrentTabClass = 'currentTab';
    options && options.transition ? this.Transition = options.transition : this.Transition = 'none';
    options && options.transitionSpeed ? this.TransitionSpeed = options.transitionSpeed : this.TransitionSpeed = 500;
    options && options.addHashValue ? this.AddHashValue = options.addHashValue : this.AddHashValue = false;
    options && options.buildCallBack ? this.BuildCallBack = options.buildCallBack : this.BuildCallBack = '';
    options && options.changeCallBack ? this.ChangeCallBack = options.changeCallBack : this.ChangeCallBack = '';
};
// QUICKBOX
interact.quickbox = function (options) {
    'use strict';
    var self = this;
    self.Opt = new interact.quickbox.opt(options);
    var closeBox = function () {
        $(self.Opt.QuickboxContainer).fadeOut(self.Opt.FadeSpeed, function () {
            $(this).empty().css('margin-top', '');
            $('#' + self.Opt.BackgroundContainerID).remove();
            if (self.Opt.CloseCallBack) {
                self.Opt.CloseCallBack(self.Opt);
            }
        });
    };
    var init = (function () {
        $(self.Opt.QuickboxActivator).on('click', function () {
            if (!$('#' + self.Opt.BackgroundContainerID).length) {
                $(self.Opt.QuickboxContainer).before('<div id="' + self.Opt.BackgroundContainerID + '"></div>');
            }
            if ($(this).is('img')) {
                // if the images links off to a larger version show this in the popup, otherwise just show the original image
                var imageLarge;
                if ($(this).parent('a').length > 0) {
                    imageLarge = $(this).parent().attr('href');
                }
                else {
                    imageLarge = $(this).attr('src');
                }
                // generate the popup window content
                $(self.Opt.QuickboxContainer).append('<div class="popUpContent"><a id="' + self.Opt.CloseLinkID + '" href="#">Close</a><img src="' + imageLarge + '" alt="' + $(this).attr('alt') + '" /></div>');
                $('.popUpContent img').load(function () {
                    $('#' + self.Opt.BackgroundContainerID).fadeIn(self.Opt.FadeSpeed);
                    $(self.Opt.QuickboxContainer).fadeIn(self.Opt.FadeSpeed, function () {
                        if (self.Opt.OpenCallBack) {
                            self.Opt.OpenCallBack(self.Opt);
                        }
                    });
                    // set width of popup box to that of the loaded image
                    $('.popUpContent').css('width', $(this).innerWidth());
                    if (self.Opt.TopIndent === 'middle') {
                        // vertically center the popup, if the popup is too high for the window fix it 20px from the top
                        var centeredIndent;
                        if (($(this).innerHeight() + 20) <= $(window).height()) {
                            centeredIndent = ($(window).height() / 2) - ($(this).innerHeight() / 2);
                        }
                        else {
                            centeredIndent = 20;
                        }
                        $(self.Opt.QuickboxContainer).css('margin-top', centeredIndent + $(window).scrollTop());
                    }
                    else {
                        $(self.Opt.QuickboxContainer).css('margin-top', self.Opt.TopIndent + $(window).scrollTop());
                    }
                });
                $('#' + self.Opt.CloseLinkID).on('click.close', function () {
                    closeBox(self.Opt);
                    return false;
                });
                $('#' + self.Opt.BackgroundContainerID).on('click.close', function () {
                    closeBox(self.Opt);
                    return false;
                });
            }
            else {
                $(self.Opt.QuickboxContainer).load($(this).attr('href'), function () {
                    $('#' + self.Opt.BackgroundContainerID).fadeIn(self.Opt.FadeSpeed);
                    $(self.Opt.QuickboxContainer).fadeIn(self.Opt.FadeSpeed, function () {
                        if (self.Opt.OpenCallBack) {
                            self.Opt.OpenCallBack(self.Opt);
                        }
                    });
                    if (self.Opt.TopIndent === 'middle') {
                        // vertically center the popup, if the popup is too high for the window fix it 20px from the top
                        var popUpHeight = $(self.Opt.QuickboxContainer + ' .popUpContent').innerHeight();
                        var centeredIndent;
                        if ((popUpHeight + 20) <= $(window).height()) {
                            centeredIndent = ($(window).height() / 2) - (popUpHeight / 2);
                        }
                        else {
                            centeredIndent = 20;
                        }
                        $(self.Opt.QuickboxContainer).css('margin-top', centeredIndent + $(window).scrollTop());
                    }
                    else {
                        $(self.Opt.QuickboxContainer).css('margin-top', self.Opt.TopIndent + $(window).scrollTop());
                    }
                });
            }
            return false;
        });
    })();
    var close = function () {
        $('#' + self.Opt.CloseLinkID).on('click.close', function () {
            closeBox(self.Opt);
            return false;
        });
        $('#' + self.Opt.BackgroundContainerID).on('click.close', function () {
            closeBox(self.Opt);
            return false;
        });
    };
    this.Close = close;
};
interact.quickbox.opt = function (options) {
    'use strict';
    options && options.quickboxContainer ? this.QuickboxContainer = options.quickboxContainer : this.QuickboxContainer = '#quickbox';
    options && options.quickboxActivator ? this.QuickboxActivator = options.quickboxActivator : this.QuickboxActivator = '.quickbox';
    options && options.backgroundContainerID ? this.BackgroundContainerID = options.backgroundContainerID : this.BackgroundContainerID = 'background';
    options && options.closeLinkID ? this.CloseLinkID = options.closeLinkID : this.CloseLinkID = 'close';
    options && options.fadeSpeed ? this.FadeSpeed = options.fadeSpeed : this.FadeSpeed = 500;
    options && options.topIndent ? this.TopIndent = options.topIndent : this.TopIndent = 'middle';
    options && options.openCallBack ? this.OpenCallBack = options.openCallBack : this.OpenCallBack = '';
    options && options.closeCallBack ? this.CloseCallBack = options.closeCallBack : this.CloseCallBack = '';
};